import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { traverse } from '../traverse/traverse';
// when media single has a invalid width, we fallback to default width
// this the last resort when revert the pixel width, we couldnt determine the correct width value
export var transformMediaSingleWidth = function transformMediaSingleWidth(adf) {
  var isTransformed = false;
  var transformedAdf = traverse(adf, {
    mediaSingle: function mediaSingle(node) {
      var _ref = node.attrs || {},
        width = _ref.width,
        widthType = _ref.widthType;

      // if width is not a number or greater than 100, and widthType is not set, we set width to 100
      if (typeof width === 'number' && width > 100 && !widthType) {
        isTransformed = true;
        var newAttrs = _objectSpread(_objectSpread({}, node.attrs), {}, {
          width: 100
        });
        return _objectSpread(_objectSpread({}, node), {}, {
          attrs: newAttrs
        });
      }
      return node;
    }
  });
  return {
    transformedAdf: transformedAdf,
    isTransformed: isTransformed
  };
};